/**
 * Re-export from the shared api-client package.
 * Implementation lives in `packages/api-client/src/hooks/useDeleteUserData.ts`.
 */
export {
  deleteUserData,
  useDeleteUserData,
  type DeleteUserDataResponse,
} from '@dramadetector/api-client';
